import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import * as googleLibPhoneNumber from 'google-libphonenumber';
import { Subscription } from 'rxjs';
import { IPaisDialCode, TelefoneIntlService } from './shared/telefoneIntl.service';

@Component({
  selector: 'app-telefone-intl',
  templateUrl: './telefone-intl.component.html',
  styleUrls: ['./telefone-intl.component.scss']
})
export class TelefoneIntlComponent implements OnInit, OnDestroy, AfterViewInit {

  paises: Array<IPaisDialCode> = []

  paisSelected: any //registro do pais selecionado
  maskPhone: string = '9*' //define a mascara do campo telefone
  isLoading: boolean = true //usado para contornar a limitacao do ngx-mask quando possui mais de uma opção de mascara

  @Input() labelCustom: any; //label do campo
  @Input() control: any; //controle que recebera o valor selecionado
  @Input() disabled: boolean = false //desabilita o componente independente se o control esta desabilitado

  subscriptions = new Subscription()

  constructor(
    private telefoneIntlService: TelefoneIntlService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.telefoneIntlService.getPaises().subscribe((retorno) => {
        this.paises = retorno
        if (this.control.value) {
          this.getMaskValue(this.control.value)
        } else {
          this.paisSelected = this.paises.find((pais) => pais.dialCode == '55')
          this.getMask(this.paisSelected.dialCode)
        }
      })
    )
  }

  setDialCode() {
    if (this.paisSelected) {
      this.getMask(this.paisSelected.dialCode)
      this.control.setValue(null)
    }
  }

  getMask(dialCode: string) {
    if (dialCode) {

      try {
        const { PhoneNumberFormat, PhoneNumberUtil, PhoneNumberType } = googleLibPhoneNumber;
        const PNF = PhoneNumberFormat;

        const phoneUtil = PhoneNumberUtil.getInstance();

        const codigoPais = phoneUtil.getRegionCodeForCountryCode(Number(dialCode))

        const formatoDialCode = dialCode.replace(/\d/g, '0')

        const tiposTelefone = [
          PhoneNumberType.FIXED_LINE,
          PhoneNumberType.MOBILE
        ]

        const mascaras = []

        for (let tipo of tiposTelefone) {
          const exemplo = phoneUtil.getExampleNumberForType(codigoPais, tipo)
          const mascara = phoneUtil.format(exemplo, PNF.NATIONAL)?.replace(/\d/g, '0')
          mascaras.push(`+${formatoDialCode} ${mascara}`)
        }
        if (this.maskPhone != mascaras.join('||'))
          this.maskPhone = mascaras.join('||')
      } catch (e) {
        this.maskPhone = '9*||9*'
      }
    } else {
      this.maskPhone = '9*||9*'
    }
  }

  inputTelefoneFocused() {
    this.isLoading = false
    if (!this.control.value)
      this.control.setValue(this.paisSelected.dialCode)
  }

  inputTelefoneBlur() {
    if (this.control.value && this.control.value == this.paisSelected.dialCode)
      this.control.setValue(null)
  }

  getMaskValue(value: string) {
    if (value) {
      try {
        if (value?.length >= 10) {
          const { PhoneNumberFormat, PhoneNumberUtil } = googleLibPhoneNumber;
          const PNF = PhoneNumberFormat;

          const phoneUtil = PhoneNumberUtil.getInstance();

          const number = phoneUtil.parse(`+${value}`)
          const mascara = phoneUtil.format(number, PNF.NATIONAL)?.replace(/\d/g, '0')
          const formatoDialCode = String(number.getCountryCode()).replace(/\d/g, '0')
          const code = phoneUtil.getRegionCodeForNumber(number)
          this.paisSelected = this.paises.find((pais) => pais.code == code)
          this.maskPhone = `+${formatoDialCode} ${mascara}`
        } else {
          this.paisSelected = this.paises.find((pais) => pais.code == 'X')
          this.maskPhone = '9*||9*'
        }
      } catch (e) {
        this.paisSelected = this.paises.find((pais) => pais.code == 'X')
        this.maskPhone = '9*||9*'
      }
    }
  }

  public isRequired() {
    const control = this.control

    if (control && control.errors) {
      if (control.errors?.['required'])
        return true
    }

    if (control && control.validator) {
      try {
        const validator = control.validator({} as AbstractControl);

        if (validator && validator['required']) {
          return true;
        }
      } catch {
        return false;
      }
    }

    return false;
  }

  inputTelefoneChange() {
    // so e chamada a funcao de mascara dinamica pelo pais se o componente foi tocado. Devido a limitacao do ngx-mask quando possui mais de uma opcao de mascara
    if (!this.isLoading && this.paisSelected)
      this.getMask(this.paisSelected.dialCode)
  }

  disabledComponent() {
    return (this.control.disabled || this.disabled) ? true : false
  }
}
